import { get, post } from "@Lib/request";
import * as ts from "@Types/business";
import { path } from "./url";

const { usedCarApiV4, usedCarApiV3, newCarApiV2, newCarApiV3, newCarApiV1 } = path;

// 活動詳情
export async function fetchActiveInfo(params) {
  return await get(`${newCarApiV2}/active/info`, params);
}

export async function fetchKind(id) {
  return await get(`${newCarApiV3}/kind/${id}`);
}

// 地區列表
export async function fetchInquiryRegion(params) {
  return await get(`${newCarApiV2}/inquiry/region`, params);
}

// 意向車款
export async function fetchInquiryKind(params) {
  return await get(`${newCarApiV2}/inquiry/kind`, params);
}

export async function fakeInquiry(params) {
  return await post(`${newCarApiV2}/inquiry`, params);
}

export async function fetchBusinessRegionsNav(params: any) {
  return await get(`${newCarApiV3}/regions/nav`, params);
}

export async function fetchBusinessShowrooms(params: ts.ShowroomsParams) {
  return await get(`${newCarApiV3}/showrooms`, params);
}

export async function fetchBusinessShowroom(params: { id: string; limit?: number }) {
  return await get(`${newCarApiV3}/showroom/${params.id}`, params);
}

export async function fetchSaledsDealers(params: { b: string }) {
  return await get(`${newCarApiV3}/saleLeads/dealers`, params);
}

export async function fetchBusinessAgents(params: ts.IAgentsParams) {
  return await get(`${newCarApiV3}/agents`, params);
}

export async function fetchBrandList(params: {
  type: "base" | "evalCompare" | "dealer" | "comment" | "showroom" | "inquiry";
}) {
  return await get(`${newCarApiV3}/brand/select`, params);
}

export async function fetchSaleLeadsNewInquiry(params: { limit: string }) {
  return await get(`${newCarApiV3}/saleLeads/newInquiry`, params);
}

export async function fetchRecommendInquiry(params: {
  inquiryId?: string;
  limit?: number;
  menuId?: number;
  ads?: number;
  rosterId?: string;
  inquiryType?: string;
}): Promise<ts.PromiseResponse<ts.IRecommendInquiry>> {
  return await get(`${newCarApiV3}/again/recommend/inquiry`, params);
}

// 菜单推荐车款
export async function fetchMenuRecommendKind(params: {
  kindId?: string;
  limit?: number;
}): Promise<ts.PromiseResponse<ts.IRecommendInquiry>> {
  return await get(`${newCarApiV3}/buycar/menu/after/recommend/kind`, params);
}
// 二次资料配置
export async function fetchRosterInformationOptions(params: {
  rosterId: string;
}): Promise<ts.PromiseResponse<ts.IRosterInformationOptions>> {
  return await get(`${newCarApiV3}/roster/information/options`, params);
}

export async function fakeRosterInformation(
  params: ts.IRosterInformationParams,
): Promise<ts.PromiseResponse<ts.IAgainInquiry>> {
  return await post(`${newCarApiV3}/roster/information`, params);
}

export async function fakeAgainInquiry(params: ts.IAgainInquiryParams): Promise<ts.PromiseResponse<ts.IAgainInquiry>> {
  return await post(`${newCarApiV3}/again/inquiry`, params);
}

export async function fakeInquirySecondInformation(
  params: ts.IInquirySecondInformationParams,
): Promise<ts.Response<ts.IInquirySecondInformation>> {
  return await post(`${newCarApiV3}/inquiry/second/information`, params);
}

// 業代競價 - 競價頁面數據API
export async function fetchInquirySecondInformation(
  params: ts.InquirySecondInformationParams,
): Promise<ts.Response<ts.InquirySecondInformation>> {
  return await get(`${newCarApiV3}/inquiry/second/information`, params);
}
